import React from 'react';
import { SearchInputDropDown } from './SearchInputDropDown';


export default React.memo(SearchInputDropDown);